import { Effect, Exit, Ref, Scope } from "effect";

/** Timers belong to the view; a fired POST joins the separate accepted owner. */
export const makeExecutionWatch = Effect.fn("Frontend.ExecutionWatch.make")(function* (owner: Scope.Scope) {
  const timers = yield* Ref.make<ReadonlyMap<"initial" | "preview" | "tests", Scope.Closeable>>(new Map());
  const stop = Effect.fn("Frontend.ExecutionWatch.stop")(function* (kind: "initial" | "preview" | "tests") {
    const previous = yield* Ref.modify(timers, current => {
      const scope = current.get(kind), next = new Map(current); next.delete(kind); return [scope, next] as const;
    });
    if (previous) yield* Scope.close(previous, Exit.void);
  });
  const cancel = Effect.all([stop("initial"), stop("preview"), stop("tests")], { discard: true });
  yield* Effect.addFinalizer(() => cancel);
  const schedule = Effect.fn("Frontend.ExecutionWatch.schedule")(function* (kind: "initial" | "preview" | "tests", delay: number, operation: Effect.Effect<void>) {
    yield* Effect.uninterruptible(Effect.gen(function* () {
      yield* stop(kind);
      if (owner.state._tag === "Closed") return;
      const timer = yield* Scope.fork(owner);
      yield* Ref.update(timers, current => new Map(current).set(kind, timer));
      yield* Effect.forkIn(Effect.sleep(delay).pipe(Effect.andThen(operation)), timer, { uninterruptible: false });
    }));
  });
  return { schedule, stop, cancel };
});
